<template>
    <div class="i-layout-menu-head" :class="{ 'i-layout-menu-head-mobile': isMobile }">
        <Menu mode="horizontal" :active-name="headerName" v-if="!isMobile && !isMenuLimit" ref="menu"
            @on-select="changeHeaderMenu">
            <MenuItem v-for="item in filterHeader" v-if="item.enable == 1" :replace="item.replace" :target="item.target"
                :name="item.path" :key="item.path">
            <i-menu-head-title :item="item" />
            </MenuItem>
        </Menu>
        <div class="i-layout-header-trigger i-layout-header-trigger-min i-layout-header-trigger-in i-layout-header-trigger-no-height"
            v-else>
            <Dropdown trigger="click" :class="{ 'i-layout-menu-head-mobile-drop': isMobile }">
                <Icon type="ios-apps" />
                <DropdownMenu slot="list">
                    <a v-for="item in filterHeader" @click="changeHeaderMenu(item.path)">
                        <DropdownItem>
                            <i-menu-head-title :item="item" />
                        </DropdownItem>
                    </a>
                </DropdownMenu>
            </Dropdown>
        </div>
    </div>
</template>
<script>
import iMenuHeadTitle from './title';
import { mapState, mapGetters } from 'vuex';
import { getStyle } from 'view-design/src/utils/assist';
import { on, off } from 'view-design/src/utils/dom';
import { throttle } from 'lodash';
import { getHeaderName, getMenuSider, getSiderSubmenu, getSiderOpenNames } from '@/libs/ab-system';
export default {
    name: 'iMenuHead',
    components: { iMenuHeadTitle },
    computed: {
        ...mapState('admin/layout', [
            'isMobile', 'menuCollapse'
        ]),
        ...mapState('admin/menu', [
            'headerName'
        ]),
        ...mapGetters('admin/menu', [
            'filterHeader'
        ])
    },
    data() {
        return {
            handleResize: () => { },
            menuWidth: 0,
            isMenuLimit: false,
            menuMaxWidth: 0 // 达到这个值后，menu 就显示不下了
        }
    },
    methods: {
        handleGetMenuHeight() {
            const $menu = this.$refs.menu;
            if ($menu) {
                const menuHeight = parseInt(getStyle(this.$refs.menu.$el, 'height'));
                // 折叠了。说明超宽了,新的最宽大于目前的最宽
                if (menuHeight > 64) {
                    if (!this.isMenuLimit) {
                        if (this.menuMaxWidth > this.menuWidth || this.menuMaxWidth === 0) {
                            this.menuMaxWidth = this.menuWidth;
                        }
                    }
                    this.isMenuLimit = true;
                } else {
                    // 不折叠才更新menu宽度，否则无需比较
                    this.menuWidth = parseInt(getStyle(this.$el, 'width'));
                }
            } else if (this.menuWidth > this.menuMaxWidth) {
                this.isMenuLimit = true;
            } else if (this.menuWidth <= this.menuMaxWidth) {
                this.isMenuLimit = false;
                this.$nextTick(() => {
                    if (this.$refs.menu) {
                        this.handleGetMenuHeight();
                    }
                });
            }
        },
        // 顶部菜单点击的时候默认获取子菜单，设置到Sider部分
        changeHeaderMenu(headName) {
            // 设置下默认菜单
            window.localStorage.oa_currentMenuPath = headName;
            // 获取全部菜单
            this.$store.dispatch('admin/db/database', { user: true }).then((db) => {
                const menuList = db.get('userMenuList').value();
                console.log(menuList)
                // 通过顶部菜单的名字，获取子菜单
                const menuSider = getMenuSider(menuList, headName);
                console.log(menuSider)
                this.$store.commit("admin/menu/setSider", menuSider);
                this.$store.commit('admin/menu/setHeaderName', headName);
                this.$store.commit('admin/menu/setActivePath', this.$route.fullPath);
                // 切换菜单时，若子菜单是默认打开的则打开，若当前页面属于某个菜单也打开
                const openNames = getSiderOpenNames(this.$route.fullPath, menuSider, true);
                this.$store.commit('admin/menu/setOpenNames', openNames);
            })
        }
    },
    watch: {
        filterHeader() {
            this.$nextTick(() => {
                this.handleGetMenuHeight();
            });
        },
        isMobile() {
            this.handleGetMenuHeight();
        },
        menuCollapse(value) {
        }
    },
    mounted() {
        //  this.handleResize = throttle(this.handleGetMenuHeight, 100, { leading: false });
        //  on(window, 'resize', this.handleResize);
        this.handleGetMenuHeight();
    },
    beforeDestroy() {
        //  off(window, 'resize', this.handleResize);
    }
}
</script>
